import React from "react";
import { useLocation, useSearch } from "wouter";
import styles from "./Subnav.module.css";

export default function Subnav() {
  const [location, navigate] = useLocation();
  const searchParams = new URLSearchParams(useSearch());

  const plan = searchParams.get("plan");

  const isSignup = location.includes("signup");

  return (
    <div className={styles.tabs}>
      <div className={isSignup ? styles.active : ''}>01 — Create Account</div>
      <div className={!isSignup ? styles.active : ''}>02 — Payment Information</div>
    </div>
  );
}
